import { NavItem } from './nav-item/nav-item';

export const navItems: NavItem[] = [

  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    bgcolor: 'primary',
    route: '/dashboards/dashboard1',
    access: true
  },
  {
    displayName: 'Charities',
    iconName: 'heart-handshake',
    bgcolor: 'secondary',
    route: '/landingpage',
    access: true
  },
  {
    displayName: 'Settings',
    iconName: 'adjustments-alt',
    bgcolor: 'secondary',
    route: '/settings',
    access: false
  },
  {
  displayName: 'Charities',
    iconName: 'heart-handshake',
  /*iconName: 'tip-jar-pound',*/
    bgcolor: 'secondary',
    route: '/charity',
    access: true,
    children: [

      //{
      //  //navCap: localStorage.getItem('FY_Year')?.toString(),
      //  navCap: 'FY 2023-24',
      //},
     
      {
        //navCap: localStorage.getItem('FY_Year')?.toString(),
        navCap: 'FY 2023-24',
        access: true
      },
      {
        displayName: 'FY 2023-24',
        iconName: 'calendar',
        access: true
      },
      {
        displayName: ' Basic Information',
        iconName: 'info-square-rounded',
        bgcolor: 'primary',
        route: '/basicinformation',
        access: true
      },
      //{
      //  displayName: 'Third Party Advisors',
      //  iconName: 'calculator',
      //  bgcolor: 'primary',
      //  route: '/thirdparty',
      //},
  {
  displayName: 'Trial Balance',
    iconName: 'calculator',
    bgcolor: 'primary',
    route: '/trialbalance',
    access: true
  },
  {
    displayName: 'Receipts & Payments',
    iconName: 'book',
    bgcolor: 'primary',
    route: '/receiptsandpayments',
    access: true
  },
  {
  displayName: 'Statement of Financial Activities (SoFA)',
    iconName: 'coins',
    bgcolor: 'primary',
    route: '/financialactivities',
    access: true
  },
  //{
  //  displayName: 'Receipts & Payments Statement',
  //  iconName: 'chart-line',
  //  bgcolor: 'primary',
  //  route: '/statement-financial-activities',
  //},
  {
    displayName: 'Balance Sheet',
    iconName: 'scale',
    bgcolor: 'primary',
    route: '/balancesheet',
    access: true
  },
{
  displayName: 'Statement of Assets & Liabilities',
    iconName: 'file',
      bgcolor: 'primary',
  route: '/assets-statements',
  access: true
  },
  {
    displayName: 'Notes to the Accounts',
    iconName: 'file',
    bgcolor: 'primary',
    route: '/Accountnotes',
    access: true
      },
      {
        //displayName: "Trustees' Annual Report",
        displayName: "Trustees' Report",
        iconName: 'report',
        bgcolor: 'primary',
        route: '/trusteeannualreport',
        access: true
      },
      //{
      //  displayName: "Statement of Trustees' Responsibility",
      //  iconName: 'clipboard-text',
      //  bgcolor: 'primary',
      //  route: '/statementoftrustees',
      //  access: true
      //},
      //{
      //  displayName: "Independent Examiner's Report",
      //  iconName: 'file-description',
      //  bgcolor: 'primary',
      //  route: '/independentexaminerreport',
      //},
      //{
      //  displayName: 'Auditor’s Report',
      //  iconName: 'fingerprint',
      //  bgcolor: 'primary',
      //  route: '/audit-report',
      //},
      {
        displayName: 'Final Accounts',
        iconName: 'file-export',
        bgcolor: 'primary',
        route: '/final-accounts',
        access: true
      },
      //{
      //  displayName: 'Submissions',
      //  iconName: 'database-share',
      //  bgcolor: 'primary',
      //  route: '/submissions',
      //  access: true
      //},
  //{
  //  displayName: 'TAR Builder',
  //  iconName: 'settings',
  //  bgcolor: 'primary',
  //  route: '/tar-builder',
  //},
  //{
  //displayName: 'Independent Examination & Audit',
  //  iconName: 'upload',
  //  bgcolor: 'primary',
  //  route: '/document-uploads',


  //  children: [
  //    {
  //      displayName: 'Independent Examiner’s Report',
  //      iconName: 'cloud-check',
  //      bgcolor: 'primary',
  //      route: '/submission-dashboard',
  //    },
  //    {
  //      displayName: 'Auditor’s Report',
  //      iconName: 'fingerprint',
  //      bgcolor: 'primary',
  //      route: '/audit-trail',
  //    },
  //    ]

  //},
  

//{
//  displayName: 'Final Accounts',
//    iconName: 'fingerprint',
//      bgcolor: 'primary',
//        route: '/audit-trail',
//  },
   

 ]
  },

  {
    displayName: 'Submission History',
    iconName: 'history',
    bgcolor: 'secondary',
    route: '/submissionHistory',
    access: false
  },
  
  {
    displayName: 'Reports',
    /*iconName: 'file-report',*/
    iconName: 'report-analytics',
    bgcolor: 'secondary',
    route: '/reports',
    access: false
  },
  {
    displayName: 'Settings',
    iconName: 'settings',
    bgcolor: 'secondary',
    route: '/settings',
    access: false
  },
];
